/**
 * WebSocket Configuration
 * Single source of truth for AI Assistant WebSocket URLs
 */

const WEBSOCKET_URLS = {
  local: "ws://localhost:8787/ws",
  production: "wss://ai-looker-upper.chang-424.workers.dev/ws",
} as const;

/**
 * Active WebSocket URL
 * Uses local in development, production otherwise
 */
export const ASSISTANT_WEBSOCKET_URL =
  import.meta.env.DEV && import.meta.env.VITE_USE_LOCAL_WS === "true"
    ? WEBSOCKET_URLS.local
    : WEBSOCKET_URLS.production;
